/** API `error.code` when the session cookie is no longer valid (user should sign in again). */
export const API_ERROR_SESSION_EXPIRED = 'SESSION_EXPIRED';
/** API `error.code` when the account has been permanently banned (returned after OTP verification). */
export const API_ERROR_ACCOUNT_BANNED = 'ACCOUNT_BANNED';
/** API `error.code` when the account is temporarily suspended (returned after OTP verification). */
export const API_ERROR_ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED';
/** API `error.code` when access is blocked due to a known abusive IP. */
export const API_ERROR_ABUSIVE_IP_BLOCKED = 'ABUSIVE_IP_BLOCKED';
/** API `error.code` when VPN attestation is required before continuing. */
export const API_ERROR_COMPLIANCE_ATTESTATION_REQUIRED = 'COMPLIANCE_ATTESTATION_REQUIRED';
/** API `error.code` when the email belongs to a permanently deleted account. */
export const API_ERROR_ACCOUNT_DELETED = 'ACCOUNT_DELETED';
//# sourceMappingURL=api-errors.js.map